<div *ngIf="!isMeVersion()" class="booking-surface-block" [class.mobile]=" deviceService.isMobile()">
  <div class="left" *ngIf="!deviceService.isMobile()">
    <div class="avatar">
      <on-ui-cover [cover]="avatar" data-test="userpic"></on-ui-cover>
    </div>
    <div class="info">
      <div class="name-wrap">
        <a [routerLink]="profileUrl" [attr.title]="fullName" class="teacher-name">{{ fullName }}</a>

        <ng-template [ngIf]="profileVerified" [ngIfElse]="noVerified">
          <app-icon class="verify" width="18" height="16" file="status" icon="teacher-verify"></app-icon>
        </ng-template>

        <ng-template #noVerified>
          <app-icon class="no-verify" width="18" height="16" file="status" icon="teacher-no-verify"></app-icon>
        </ng-template>
      </div>
      <div class="statistics-wrap">
        <ng-container *ngTemplateOutlet="statistics"></ng-container>
      </div>
    </div>
  </div>
  <div class="right">
    <div class="prices">
      <span class="price-title">{{ 'teacher-card.from' | translate }}</span>
      <span
        class="price-value">{{ minPriceTier ? (getFormattedAmount() | async) : 0 }}</span>
      <span>{{ 'teacher-card.hr' | translate }}</span>
    </div>
    <ng-template [ngIf]="canSignup$ | async" [ngIfElse]="cantSignupRef">
      <on-ui-button class="secondary"
                    label="teacher-card.actions.sign-up"
                    (onclick)="openCheckoutModal()">
      </on-ui-button>
    </ng-template>
    <ng-template #cantSignupRef>
      <on-ui-button class="status"
                    label="teacher-card.actions.no-available-hours">
      </on-ui-button>
    </ng-template>
  </div>
</div>

<ng-template #statistics>
  <section class="stats">
    <div class="line-1">
      <div *ngFor="let item of statsLine1; let last = last; trackBy: trackByFn" class="stat">
        <span class="stat-title">{{ item.title | translate }}: {{ item.value }}</span>
        <span class="point" *ngIf="!last"></span>
      </div>
    </div>

    <div class="line-2">
      <div *ngFor="let stat of statsLine2; let last = last; trackBy: trackByFn" class="stat">
        <span class="stat-title label">{{ stat.title | translate }}</span>
        <span class="stat-title">{{ stat.value }}</span>
        <span class="point"></span>
      </div>
      <div class="stats">
        <app-rating [stats]="teacher?.stats" [user]="teacher"></app-rating>
      </div>
    </div>
  </section>
</ng-template>

<app-modal *ngIf="deviceService.isDesktop() && userServiceCardFullInModal"
           [canClose]="false"
           (closed)="onToggleUserServiceInModal()">
  <app-modal-body>
    <app-user-service-card-full [userService]="openedUserService"
                                [modal]="true"
                                (inViewportChange)="onIinViewportChange($event)">
    </app-user-service-card-full>
  </app-modal-body>
  <app-modal-ad>
    <ng-template [ngIf]="!surfaceBlockDisplay">
      <app-user-service-surface-block [userService]="openedUserService"></app-user-service-surface-block>
    </ng-template>
  </app-modal-ad>
</app-modal>

<app-mobile-modal *ngIf="!deviceService.isDesktop() && userServiceCardFullInModal"
                  [titleVisible]="true"
                  (closed)="onToggleUserServiceInModal()">
  <app-mobile-modal-body>
    <app-user-service-card-full [userService]="openedUserService" [modal]="true"></app-user-service-card-full>
  </app-mobile-modal-body>
</app-mobile-modal>
